import React, { useEffect, useState } from 'react';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
const purchases = [{
  name: 'Megan R.',
  location: 'Denver, Colorado'
}, {
  name: 'Jennifer S.',
  location: 'Boston, Massachusetts'
}, {
  name: 'Kelly A.',
  location: 'Minneapolis, Minnesota'
}, {
  name: 'Lauren T.',
  location: 'Salt Lake City, Utah'
}, {
  name: 'Danielle P.',
  location: 'Chicago, Illinois'
}];
export function UrgencyBanner() {
  const [visible, setVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const showPopup = () => {
      setCurrentPurchase(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      window.setTimeout(() => setVisible(false), 6500);
    };
    const initialTimer = window.setTimeout(showPopup, 3500);
    const interval = window.setInterval(showPopup, 18000);
    return () => {
      window.clearTimeout(initialTimer);
      window.clearInterval(interval);
    };
  }, []);
  if (!visible) return null;
  return <aside className="pointer-events-none fixed bottom-3 left-3 right-3 z-50 flex justify-center animate-slide-in sm:left-auto sm:right-4 sm:justify-end" aria-live="polite" data-id="element-173" data-mp="27gau5f7egtkm">
      <div className="pointer-events-auto relative w-full max-w-[308px] overflow-hidden rounded-lg border-2 border-brand-gold bg-brand-navy p-2.5 pr-8 text-white shadow-[0_8px_24px_rgba(15,39,74,0.38)]" data-id="element-174" data-mp="1xpydvz6mbmka">
        <div className="absolute inset-x-0 top-0 h-1 bg-brand-gold" data-id="element-175" data-mp="2qcj0kmc5fahi" />
        <button onClick={() => setVisible(false)} aria-label="Close purchase notification" className="absolute right-1.5 top-1.5 rounded p-0.5 text-white/60 hover:text-white focus:outline-none focus:ring-2 focus:ring-brand-ice" data-id="element-176" data-mp="2ldzgkrh488rs">
          <XIcon className="h-4 w-4" data-id="element-177" data-mp="2cd19u1faln5i" />
        </button>
        <div className="flex items-center gap-2.5" data-id="element-178" data-mp="1509bbhe9fegk">
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-brand-ice bg-brand-ice/20" data-id="element-179" data-mp="151srl7zx1pic">
            <ShoppingBagIcon className="h-4 w-4 text-brand-ice" data-id="element-180" data-mp="1110ge97hhajf" />
          </div>
          <div className="leading-tight" data-id="element-181" data-mp="12gky5qtjha0j">
            <p className="text-xs font-bold" data-id="element-182" data-mp="17fftfs8p0r1j">{currentPurchase.name}</p>
            <p className="text-[10px] font-medium text-white/70" data-id="element-183" data-mp="17cjvw50rc4dm">from {currentPurchase.location}</p>
            <p className="mt-0.5 text-[11px] font-bold text-brand-ice" data-id="element-184" data-mp="sjztj6lfm0x8">just purchased FIGURE SKATING READY™</p>
          </div>
        </div>
      </div>
    </aside>;
}